export default __webpack_public_path__ + "static/media/4.ffc5a52c.png";